"use client";

import { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import NavList from "../NavList";
import { useAuth } from "../../../context/AuthContext";
import { changeAdminPassword } from "../../../api/api"; // use API wrapper

const ChangePasswordForm = () => {
  const { user } = useAuth();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      return alert("New password and confirm password do not match!");
    }

    setLoading(true);

    try {
      const res = await changeAdminPassword(oldPassword, newPassword);
      alert(res.msg || "Password changed successfully");

      // Reset form
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      console.error("Change password error:", err);
      alert(err.msg || "Failed to change password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-4 rounded-3 mb-4">
      <NavList />

      <Form onSubmit={handleSubmit}>
        <Row>
          <Col lg={6}>
            <Form.Group className="mb-4">
              <label className="label text-secondary">Old Password</label>
              <Form.Control
                type="password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                required
              />
            </Form.Group>
          </Col>

          <Col lg={6}>
            <Form.Group className="mb-4">
              <label className="label text-secondary">New Password</label>
              <Form.Control
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </Form.Group>
          </Col>

          <Col lg={12}>
            <Form.Group className="mb-4">
              <label className="label text-secondary">Confirm Password</label>
              <Form.Control
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </Form.Group>
          </Col>

          <Col lg={12}>
            <button
              type="submit"
              className="btn btn-primary py-2 px-4"
              disabled={loading}
            >
              {loading ? "Updating..." : "Change Password"}
            </button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ChangePasswordForm;